import { ISP_AirDuct } from './types'
import { TrendPanel } from './TrendPanel';
import { useGetObjectsChildren } from '../../../hooks/useGetObjectsChildren';
import { useStyletron } from 'baseui';



export function SmallPanelTrendOnly(props: ISP_AirDuct) {
    const [,theme] = useStyletron()
    const { children: childElements} = useGetObjectsChildren(props.resourceGroupId,props.id)

    const temperature = childElements?.find((v: any) => v.schema === "AutomationApps.Devices.Sensors.TemperatureSensor");
    const humidity = childElements?.find((v: any) => v.schema === "AutomationApps.Devices.Sensors.HumiditySensor");
    const pressure = childElements?.find((v: any) => v.schema === "AutomationApps.Devices.Sensors.PressureSensor");


    return (
        <>
            <TrendPanel temperature={temperature} humidity={humidity} pressure={pressure} />
        </>
    );
}